import { Token } from "./token";

export class FakeToken extends Token {}
